import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function TermsPage() {
  return (
    <>
      <Header />
      <main className="bg-[#FAFAFA] pt-32 pb-16">
        <div className="max-w-[780px] mx-auto px-5 sm:px-8 lg:px-10">
          <Link
            to="/"
            className="inline-block text-[13px] text-[#173B86] hover:underline mb-6"
          >
            ← Back to home
          </Link>
          <h1 className="font-serif text-[34px] sm:text-[42px] text-[#173B86] mb-2">
            Website Terms of Service
          </h1>
          <p className="text-[13px] text-[#5b6a85] mb-10">
            Last updated: February 2026
          </p>

          <div className="space-y-8 text-[14.5px] leading-[1.7] text-[#1A2B4A]/90">
            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                1. General Terms
              </h2>
              <p>
                These terms apply to all services provided by Tina's Cleaning
                Company. Booking or requesting service means acceptance of
                these terms.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                2. Pricing &amp; Booking
              </h2>
              <p className="mb-3">
                Final pricing is confirmed before service and may vary
                depending on:
              </p>
              <ul className="list-disc pl-5 space-y-1.5">
                <li>property condition</li>
                <li>level of dirtiness</li>
                <li>pet-related odors or damage</li>
                <li>post-construction or heavily neglected conditions</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                3. Payment
              </h2>
              <p className="mb-2">
                Payment is due immediately after completion while the cleaning
                team is still on-site.
              </p>
              <p>
                Additional services are charged separately and must be
                approved in advance.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                4. Cancellations
              </h2>
              <p className="mb-2">
                At least 24 hours' notice is required for cancellations or
                rescheduling.
              </p>
              <p>Late cancellations may be charged for reserved time.</p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                5. Access
              </h2>
              <p className="mb-3">The client is responsible for:</p>
              <ul className="list-disc pl-5 space-y-1.5 mb-3">
                <li>providing access (keys, codes, lockbox)</li>
                <li>ensuring access at scheduled time</li>
                <li>communicating special conditions</li>
              </ul>
              <p>
                If access is not available or the client is unreachable, the
                booking may be considered completed.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                6. Scope of Work
              </h2>
              <p className="mb-3">
                Standard cleaning includes general surfaces, floors, bathrooms,
                and kitchen areas.
              </p>
              <p className="mb-3">Additional services (extra charge):</p>
              <ul className="list-disc pl-5 space-y-1.5">
                <li>inside oven and refrigerator</li>
                <li>dishwashing</li>
                <li>washer and dryer cleaning</li>
                <li>windows and doors</li>
                <li>walls and ceilings (spot or full)</li>
                <li>laundry</li>
                <li>organizing and decluttering</li>
                <li>inside cabinets and drawers</li>
                <li>heavy dirt, grease, odors, pet-related issues</li>
                <li>post-construction or heavily dirty homes</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                7. Inspection Policy
              </h2>
              <p className="mb-2">
                The client must inspect the service immediately upon completion
                before the team leaves.
              </p>
              <p className="mb-2">Any concerns must be reported on-site.</p>
              <p className="mb-2">
                After departure, return visits may not be provided.
              </p>
              <p>
                If the client is not present, before/after photos will be
                provided.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                8. Liability
              </h2>
              <p className="mb-2">We are a licensed and insured company.</p>
              <p>
                Liability is limited to the services provided. We are not
                responsible for pre-existing conditions or hidden defects.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-[22px] text-[#173B86] mb-3">
                9. Contact
              </h2>
              <p>
                <a
                  href="mailto:taniamac90210@gmail.com"
                  className="text-[#173B86] hover:underline"
                >
                  taniamac90210@gmail.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
